const config = {
    type: 'MULTIMEDIA',
    component: "Smu08",
    portrait: "/img/container/S-MU-08.jpg",
    body: {
        title: '',
        description:'',
        video_id: ''
    },
}

export { config }